export const ADD_BOOKING = 'booking/add';
export const DELETE_BOOKING = 'booking/delete';